import { TCanvas } from '.'
import { initialCanvasConfig } from '../editor.config'
import { TDesignSide, IEditorWidget, TEditorConfig } from '../editor.types'
import {
  getColorPickerKeys,
  getInitialWidgetConfig,
  getResetCanvasColors,
  mapProductSpecsToCanvas,
} from '../editor.utils'

const checkForLegacyCanvasConfig = (
  canvasConfig: Record<TDesignSide, TCanvas> | TCanvas | any,
  widgets: IEditorWidget[] = []
) => {
  if (!canvasConfig) {
    return null
  }

  if (typeof canvasConfig.front === 'undefined') {
    return {
      front: { ...canvasConfig, widgets },
      back: null,
    }
  }

  return canvasConfig
}

function getInitialCanvasConfig({
  editorConfig,
}: {
  editorConfig: TEditorConfig
}) {
  const initialWidgetConfig = getInitialWidgetConfig({ editorConfig })
  const canvasSize = mapProductSpecsToCanvas(editorConfig)

  return {
    ...initialCanvasConfig,
    ...getResetCanvasColors({
      enabledPickers: getColorPickerKeys(editorConfig?.productColorConfig),
      material: editorConfig?.material,
      productColorOption: editorConfig?.productColorOption,
    }),
    ...canvasSize,
    shape: editorConfig?.shape,
    widgets: [initialWidgetConfig],
    activeWidgetId: initialWidgetConfig?.id,
    activeWidgetType: initialWidgetConfig?.type,
  }
}

export { checkForLegacyCanvasConfig, getInitialCanvasConfig }
